module.exports = __webpack_public_path__ + "img/banner.2af0559c.jpg";